import type { GraderMode, Stroke } from '@/lib/grader'

export interface DrawCapturePayload {
    dataKey: string
    graderMode: GraderMode
    resolution: 'overridden' | 'conceded'
    overrideBlocked: boolean
    matchScore: number
    threshold: number
    perStroke: number[]
    userStrokeCount: number
    targetStrokeCount: number
    strokes: Array<Array<{ x: number; y: number }>>
    targetHash: string
    graderVersion: string
    drawDurationMs: number | null
    inputType: string
}

/** Round ink to 2 decimals — 0.01 of the 109-unit viewBox is sub-pixel. */
export function roundStrokes(
    strokes: Stroke[]
): Array<Array<{ x: number; y: number }>> {
    return strokes.map((s) =>
        s.map((p) => ({
            x: Math.round(p.x * 100) / 100,
            y: Math.round(p.y * 100) / 100,
        }))
    )
}

/** sha256 hex of the graded target definition (spec §9.1: digest, not copy). */
export async function hashTarget(
    strokePaths: string[],
    samplesPerStroke: number
): Promise<string> {
    const text = `${samplesPerStroke}:${strokePaths.join('|')}`
    const digest = await crypto.subtle.digest(
        'SHA-256',
        new TextEncoder().encode(text)
    )
    return Array.from(new Uint8Array(digest))
        .map((b) => b.toString(16).padStart(2, '0'))
        .join('')
}
